export const setRecordsPagination = {
  SET_RECORDS_PAGINATION(state, payload) {
    state.recordsPagination = payload;
  }
};
